export const REDACTION_MARKER = 'redaction-marker';
export const REDACTION_MARKER_VIEWER = 'redaction-marker-viewer';
export const ACTION_MENU_REDACTION = 'issue-action-menu-button';
